export const payload = {
  receiveMutation: 'RECEIVE_DEPARTMENTS',
  receivingMutation: 'RECEIVING_DEPARTMENTS',
  receiveMetadataMutation: 'RECEIVE_DEPARTMENTS_METADATA',
  receiveFailureMutation: 'RECEIVE_DEPARTMENTS_FAILURE',
  savingMutation: 'SAVING_DEPARTMENTS',
  saveFailureMutation: 'SAVING_DEPARTMENTS_FAILURE',
  incrementMutation: 'INCREMENT_DEPARTMENTS_COUNT',
  updatingMutation: 'UPDATING_DEPARTMENTS',
  updateFailureMutation: 'UPDATING_DEPARTMENTS_FAILURE',
  deleteMutation: 'DELETE_DEPARTMENTS',
  deletingMutation: 'DELETING_DEPARTMENTS',
  deleteFailureMutation: 'DELETING_DEPARTMENTS_FAILURE',
  resetMetaMutation: 'RESET_DEPARTMENTS_META',
  clearMutation: 'CLEAR_DEPARTMENTS_STATE',
  moduleName: 'department',
  endpoint: 'departments',
  defaultModelGetter: 'getDefaultDepartment',
  searchableFields: ['id', 'code', 'name', 'description']
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Departments/actionPayload.js